import { render } from "./AnimatedNumberInput.vue?vue&type=template&id=fe98328a&scoped=true&ts=true"
import script from "./AnimatedNumberInput.vue?vue&type=script&lang=ts"
export * from "./AnimatedNumberInput.vue?vue&type=script&lang=ts"

import "./AnimatedNumberInput.vue?vue&type=style&index=0&id=fe98328a&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe98328a"]])

export default __exports__